import { StaticProvider } from '@angular/core';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';
import {
  VisualizationDashboardAclService,
  VisualizationDashboardGitService,
  VisualizationDashboardQuery,
  VisualizationDashboardService,
  VisualizationDashboardStore,
} from '@y42/visualization/dashboard';
import { VisualizationTabQuery } from '@y42/visualization/tab';
import { VisualizationDashboardTabs } from '../visualization-dashboard-tabs.constant';

export const VisualizationDashboardFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.VisualizationDashboard,
    GIT_FOLDER: Y42GitFolders.VisualizationDashboard,
    FEATURE_ROUTE: Y42Routes.VisualizationDashboard,
    DETAIL_TABS: VisualizationDashboardTabs,
    AbstractFeatureService: VisualizationDashboardService,
    AbstractFeatureQueryEntity: VisualizationDashboardQuery,
    AbstractFeatureEntityStore: VisualizationDashboardStore,
    AbstractFeatureGitService: VisualizationDashboardGitService,
    AbstractFeatureAclService: VisualizationDashboardAclService,
    AbstractFeatureChildQueryEntity: VisualizationTabQuery,
  };
};

export function VisualizationDashboardProviders(): StaticProvider[] {
  return provideFeature(VisualizationDashboardFeatureProviders());
}
